
declare const grecaptcha: any;


/** Submits the contact form identified by the given selector */
export function submitContactForm(target: HTMLElement | string) {
    const form = target instanceof HTMLElement ? target : document.querySelector(target);
    const inputs = {
        firstName: form.querySelector('input[name="first_name"]') as HTMLInputElement,
        lastName: form.querySelector('input[name="last_name"]') as HTMLInputElement,
        email: form.querySelector('input[name="email"]') as HTMLInputElement,
        phone: form.querySelector('input[name="phone_number"]') as HTMLInputElement,
        comments: form.querySelector('textarea[name="comments"]') as HTMLTextAreaElement
    };
    const button = form.querySelector('button[type="submit"]') as HTMLButtonElement;
    const errorMessage = form.querySelector('.error-message') as HTMLElement;
    const loadingMessage = form.querySelector('.loading-message') as HTMLElement;
    const successMessage = form.querySelector('.success-message') as HTMLElement;

    const data = {
        firstName: inputs.firstName ? inputs.firstName.value || null : null,
        lastName: inputs.lastName ? inputs.lastName.value || null : null,
        email: inputs.email ? inputs.email.value || null : null,
        phone: inputs.phone ? inputs.phone.value || null : null,
        comments: inputs.comments ? inputs.comments.value || null : null
    };

    button.disabled = true;
    loadingMessage.classList.add('visible');

    submitContactData(data, window.location.pathname.replace(/\/$/, '') || 'main')
        .then(() => {
            successMessage.classList.add('visible');
        })
        .catch(err => {
            errorMessage.classList.add('visible');
        })
        .finally(() => {
            loadingMessage.classList.remove('visible');
            button.disabled = false;
            button.style.display = 'none';
        })
}


/** Sends the contact information to Salesforce */
async function submitContactData(data: ContactData, page: string): Promise<void> {
    const captchaKey = await new Promise<string>((resolve, reject) => {
        grecaptcha.ready(() => {
            grecaptcha.execute('6LeKT6IUAAAAAK9Q8-jZExhaLWMKtgAojCR3TRRP', {
                action: 'contact_form'
            }).then(key => resolve(key), err => reject(err));
        });
    });

    const saveRequest = new Request('https://starlight.secure.force.com/prospects/services/apexrest/slc/ProspectService.AddProspect', {
        method: 'POST',
        headers: {
            'Content-Type': "application/json"
        },
        mode: 'cors',
        cache: 'no-cache',
        body: JSON.stringify({
            prospect: data,
            page: page,
            captchaKey: captchaKey
        })
    });

    const res = await fetch(saveRequest);
    if(res.status >= 400) {
        throw new Error(`Unable to send request`);
    }
}


interface ContactData {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    comments: string;
}
